// extracted by mini-css-extract-plugin
export default {"bottom_border":"SearchTemplate_bottom_border__je1mN"};